/* ===== Login Page ===== */

import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Lock, LogIn, Mail } from 'lucide-react'
import { useApp } from '@/presentation/providers/useApp'
import { Card } from '@/presentation/components/ui/Card'
import { Button } from '@/presentation/components/ui/Button'
import { Input } from '@/presentation/components/ui/Input'

export function LoginPage() {
  const { isLoading, signIn } = useApp()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault()
    setErrorMessage(null)

    try {
      const signedProfile = await signIn(email, password)
      navigate(signedProfile?.isSuperAdmin ? '/admin/saas' : '/dashboard')
    } catch {
      setErrorMessage('No pudimos iniciar sesion. Revisa el correo y la contrasena.')
    }
  }

  return (
    <div className="app-shell flex min-h-screen items-center justify-center p-4">
      <Card className="w-full max-w-md p-8 shadow-modal">
        <div className="text-center mb-6">
          <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-[14px] bg-gradient-to-br from-primary-500 to-[#8e67ff] text-2xl font-bold text-white shadow-glow">
            Z
          </div>
          <h1 className="text-2xl font-bold text-neutral-900 dark:text-neutral-100 ">Zetyar Nexo</h1>
          <p className="text-xs text-neutral-500 dark:text-neutral-400 mt-1">Conecta personas, proyectos y organizaciones.</p>
        </div>

        {errorMessage && (
          <div className="mb-4 rounded-md border border-danger-200 bg-danger-50 px-3 py-2 text-sm text-danger-700 dark:border-danger-900/70 dark:bg-danger-950/40 dark:text-danger-200">
            {errorMessage}
          </div>
        )}

        <form onSubmit={handleLogin} className="space-y-4">
          <Input
            label="Correo electronico"
            type="email"
            placeholder="correo@ejemplo.com"
            leftIcon={<Mail className="w-4 h-4 text-neutral-400" />}
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <div className="space-y-1">
            <Input
              label="Contrasena"
              type="password"
              placeholder="********"
              leftIcon={<Lock className="w-4 h-4 text-neutral-400" />}
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <div className="flex justify-end">
              <button
                type="button"
                className="text-xs font-semibold text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 focus:outline-none transition-colors"
                onClick={() => navigate('/forgot-password')}
              >
                ¿Olvidaste tu contraseña?
              </button>
            </div>
          </div>

          <Button
            fullWidth
            variant="primary"
            size="lg"
            type="submit"
            leftIcon={<LogIn className="w-5 h-5" />}
            disabled={isLoading}
          >
            {isLoading ? 'Iniciando...' : 'Iniciar sesion'}
          </Button>
        </form>

        <div className="mt-6 text-center text-xs text-neutral-500 dark:text-neutral-400">
          Solicita una invitacion al administrador de tu organizacion.
        </div>
      </Card>
    </div>
  )
}
